// extracted by mini-css-extract-plugin
export var accent = "NumberInput-module--accent--f9576";
export var clearButton = "NumberInput-module--clearButton--b1a2a";
export var container = "NumberInput-module--container--ea1e0";
export var input = "NumberInput-module--input--55930";
export var inputWrapper = "NumberInput-module--inputWrapper--63507";
export var unit = "NumberInput-module--unit--378de";
export var withClearButton = "NumberInput-module--withClearButton--602d5";
export var withUnit = "NumberInput-module--withUnit--cd27b";